import type { FC, PropsWithChildren } from 'react'

import { Link } from 'react-router-dom'

import { useAppContext } from '@/app/index.context'
import { Translation } from '@/app/translations/Translation'
import RouterLink from '@/components/RouterLink'
import { APP_ROUTES } from '@/util/app-routes'

import { useDrillDownContext } from './context/index.context'

import './BreadCrumbs.styles.scss'

export const BreadCrumbs: FC<PropsWithChildren> = ({ children }) => {
  const { whiteLabel } = useAppContext()
  const { state } = useDrillDownContext()

  return (
    <div className={`bread-crumbs ${whiteLabel}`}>
      <h2>
        <Link
          to={`${APP_ROUTES.REPORTS_DRILL_DOWN}?${new URLSearchParams({
            year: String(state.year),
            period: String(state.period),
          })}`}
        >
          <Translation id="drilldown" />
        </Link>
      </h2>
      {children}
    </div>
  )
}

export const Crumb: FC<{ route: string; name: string; params: { [key: string]: string } }> = ({
  route,
  name,
  params,
}) => (
  <RouterLink to={`${route}?${new URLSearchParams(params)}`} hasUnderline={false}>
    {name}
  </RouterLink>
)
